
//Importaciones
import React from 'react'
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CLabel from '../../../../../Common/CLabel';
import { IconButton, mergeStyleSets, css, TooltipHost, TooltipOverflowMode, Icon } from '@fluentui/react';
import DialogAction from './DialogAction';
import moment from 'moment';
import { useBoolean } from '@fluentui/react-hooks';
import { useState } from 'react';
import { isNullOrEmpty } from '../../../../../../common/Helpers';
import { action_setGapSelectedActionToDialog } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';


function GapActionCard(props) {
    //Helpers
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //Parametros de entrada.
    const {
        inputParam_EditMode = null,
        inputParam_ActionItem = null,
        inputParam_GapElementId = null,
        inputParam_ShowSeparatorStyle = true,
        inputParam_SetterCauseActionList = null,
        inputParam_ShowCause = false,
        inputParam_ShowVariableName = false,
        inputParam_GapAnalyzeId = null,
        inputParam_DataserieValueChartSelected = null,
        inputParam_SelectedCauses = [],
        inputParam_InvertClass = false,
        inputParam_Dflex_Buttons = false,
    } = props;

    const { _selectedActionToDialog: selectedActionToDialog } = useSelector((state) => state.gapScope);

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
    });
    //Funciones de componente.
    const onSelectActionToDialog = (action) => {
        console.log(action)
        dispatch(action_setGapSelectedActionToDialog(action))
        showDialog()
    }
    //Render de componente.
    return  <Row className={`${inputParam_ShowSeparatorStyle ? 'border-bottom pt-0 ps-2' : ''}`}>
                <Col className={!inputParam_InvertClass ? 'd-flex' : 'col-auto mx-auto my-auto'}>
                    <Row>
                        {
                            (inputParam_ActionItem.l_GapRevision && inputParam_ActionItem.l_GapRevision.length > 0) &&
                            <Col className={inputParam_InvertClass ? 'col-xl-8' : 'col-auto'}>
                                <Row>
                                    <Col>
                                        <CLabel labelText={t('data-lang-lbl-revision')} labelValue={inputParam_ActionItem.l_GapRevision[0].title }/>
                                    </Col>
                                </Row>
                            </Col>
                        }
                        <Col className={inputParam_InvertClass ? 'col-xl-8' : 'col-auto'}>
                            <Row>
                                <Col>
                                    <TooltipHost
                                        content={ inputParam_ActionItem.title }
                                        overflowMode={TooltipOverflowMode.Self}
                                        hostClassName={css(classNames.overflow)}
                                        onTooltipToggle={false}
                                        styles={{
                                            root: { display: 'flex', width: "100%" },
                                        }}
                                    >
                                        <CLabel labelText={t('data-lang-lbl-action')} labelValue={ inputParam_ActionItem.title }/>
                                    </TooltipHost>
                                </Col>
                            </Row>
                            {
                                (inputParam_ActionItem.variableName && inputParam_ShowVariableName === true) &&
                                <Row>
                                    <Col>
                                        <CLabel labelText={t('data-lang-lbl-kpi')} labelValue={inputParam_ActionItem.variableName}/>
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col className={inputParam_InvertClass ? 'col-auto' : 'col-xl-8'}>
                            <Row title={inputParam_ActionItem.action}>
                                <Col>
                                    <CLabel labelText={t('data-lang-lbl-status')} labelValue={ t(`data-lang-skaction-status${inputParam_ActionItem.statusId === 0 ? 1 : inputParam_ActionItem.statusId}`) }/>
                                </Col>
                            </Row>
                            {
                                inputParam_ActionItem.item_gap_revision && inputParam_ActionItem.item_gap_revision.title &&
                                <Row title={inputParam_ActionItem.item_gap_revision}>
                                    <Col>
                                        <CLabel labelText={t('data-lang-lbl-revision')} labelValue={ inputParam_ActionItem.item_gap_revision.title }/>
                                    </Col>
                                </Row>
                            }
                            {
                                inputParam_ActionItem.serieTimeStr &&
                                <Row>
                                    <Col>
                                        <CLabel labelText={t('data-lang-lbl-period')} labelValue= {inputParam_ActionItem.serieTimeStr}/>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                </Col>
                <Col className={(!inputParam_InvertClass ? 'col-auto mx-auto my-auto' : '') + (inputParam_Dflex_Buttons ? ' d-flex' : '')}>
                    <Row>
                        <Col className='d-flex'>
                            {
                                !isNullOrEmpty(inputParam_ActionItem.endDate) &&
                                <div className={'mx-1 ' + (inputParam_Dflex_Buttons ? 'mt-2' : '')}>
                                    <TooltipHost content={ `${t('data-lang-lbl-date')}: ${moment(inputParam_ActionItem.beginDate).format("DD/MM/YYYY")} - ${moment(inputParam_ActionItem.endDate).format("DD/MM/YYYY")}` } >
                                        <Icon iconName="Calendar" style={{ fontSize: "14px", cursor: "pointer" } } />
                                    </TooltipHost>
                                </div>
                            }
                            <div className={'mx-1 ' + (inputParam_Dflex_Buttons ? 'mt-2' : '')}>
                                <TooltipHost content={ `${t('data-lang-lbl-responsible')}: ${inputParam_ActionItem.owner}` } >
                                    <Icon iconName="People" style={{ fontSize: "14px", cursor: "pointer" }}/>
                                </TooltipHost>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mx-auto col-auto'>
                            <TooltipHost content={ t('data-lang-btn-moredata') } calloutProps={{ gapSpace: 0 }} styles={{ root: { display: 'inline-block' } }} >
                                <IconButton iconProps={{ iconName: 'View'  }} onClick={() => onSelectActionToDialog(inputParam_ActionItem)} />
                            </TooltipHost>
                        </Col>
                    </Row>
                </Col>
                {
                    selectedActionToDialog && isDialogVisible &&
                    <DialogAction
                        inputParam_GapElementId={inputParam_GapElementId}
                        inputParam_EditMode={inputParam_EditMode}
                        inputParam_IsDialogOpen={isDialogVisible}
                        inputParam_SetterIsDialogOpen={hideDialog}
                        inputParam_DialogEntity={selectedActionToDialog}
                        inputParam_SetterCauseActionList={inputParam_SetterCauseActionList}
                        inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                        inputParam_DataserieValueChartSelected={inputParam_DataserieValueChartSelected}
                        inputParam_SelectedCauses={inputParam_SelectedCauses}
                    />
                }
            </Row>;
}

///Proptypes
GapActionCard.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ActionItem: PropTypes.object.isRequired,
    inputParam_ShowSeparatorStyle: PropTypes.bool.isRequired,
    inputParam_SetterCauseActionList: PropTypes.func,
    inputParam_ShowCause: PropTypes.bool,
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_DataserieValueChartSelected: PropTypes.number,
    inputParam_SelectedCauses: PropTypes.array,
};

export default GapActionCard;
